import { useEffect, useState } from 'react'
import { inscreverEmVersaoNova, verificarVersaoPublicada } from './versao-publicada'

const INTERVALO_DE_CHECAGEM = 5 * 60 * 1000

export const useNewVersion = () => {
  const [temVersaoNova, setTemVersaoNova] = useState(false)

  useEffect(() => {
    const desinscrever = inscreverEmVersaoNova(setTemVersaoNova)

    void verificarVersaoPublicada()
    const intervalo = setInterval(() => void verificarVersaoPublicada(), INTERVALO_DE_CHECAGEM)

    return () => {
      desinscrever()
      clearInterval(intervalo)
    }
  }, [])

  return { temVersaoNova }
}
